module.exports = __webpack_public_path__ + "static/media/LOR_Dr.Green_BGSU.f60ffa81.pdf";